<template>
  <div class="block">
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-3/4 p-2">
        <div class="c-div c-SET-mini mx-auto">
          <highcharts :options="buildChart('union')" />
        </div>
      </div>

      <div class="w-full lg:w-1/4 bg-white rounded-lg p-2">
        <div class="text-center mx-auto my-4">
          <img src="/i-SET.png" class="h-20 mb-3 mx-auto" />
          <span class="text-2xl font-bold"> Insights </span>
        </div>

        <ul id="insights" class="mt-3 h-72 overflow-x-auto overflow-y-auto">
          <li
            v-for="insight in insights"
            :key="`${insight.name.toLowerCase().replace(/\s/g, '-')}-${Math.random()}`"
            class="rounded-lg shadow pb-2 mx-8 my-4 w-5/6 relative"
          >
            <span class="flex mb-8 text-lg">
              <span class="ml-1 mr-2" :class="{ 'my-auto': insight.icon === 'gpt' }">
                <gpt-icon v-if="insight.icon === 'gpt'" :width="15" :height="15" />
                <font-awesome-icon v-else :icon="insight.icon" />
              </span>
              {{ insight.name }}
            </span>
            <span class="ml-3 text-indigo">
              {{ insight.actions.length }} {{ insight.actions.length > 1 ? 'insights' : 'insight' }}
            </span>
            <button
              class="flex items-center btn-indigo absolute bottom-1.5 right-1.5"
              type="button"
              @click="showActions(insight.actions)"
            >
              Abrir
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="config.answers" class="flex flex-wrap mt-12">
      <div v-if="hasChart('manager')" class="w-full lg:w-1/3 p-2">
        <highcharts :options="buildChart('manager', 500, 500)" />
      </div>
      <div v-if="hasChart('resident')" class="w-full lg:w-1/3 p-2">
        <highcharts :options="buildChart('resident', 500, 500)" />
      </div>
      <div v-if="hasChart('visitant')" class="w-full lg:w-1/3 p-2">
        <highcharts :options="buildChart('visitant', 500, 500)" />
      </div>
    </div>

    <insight-modal
      v-show="show"
      ref="modal"
      :insights="actions"
      :questionnaire="questionnaire"
      :state="state"
      :city="city"
      @close="show = false"
    />
  </div>
</template>

<script>
import { Chart as highcharts } from 'highcharts-vue'
import HighCharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import GptIcon from '@/Shared/GPTIcon'
import InsightModal from './InsightModal.vue'

HighchartsMore(HighCharts)

export default {
  components: {
    highcharts,
    GptIcon,
    InsightModal,
  },
  props: {
    questionnaire: String,
    state: String,
    city: String,
    charts: Object,
    config: Object,
    insights: Array,
  },
  data() {
    return {
      show: false,
      actions: [],
    }
  },
  methods: {
    showActions(actions) {
      this.actions = actions
      this.$refs.modal.assembleModels(actions)
      this.show = true
      setTimeout(this.$refs.modal.showFirstTypeAction, 1e3)
    },
    hasChart(type) {
      return Boolean(this.charts[type])
    },
    buildChart(type, w = 870, h = 850) {
      return {
        chart: {
          polar: true,
          type: 'area',
          height: h,
          width: w,
        },
        title: {
          text: this.charts[type]['title'],
        },
        legend: {
          enabled: false,
        },
        subtitle: {
          text: `${this.questionnaire} (${this.state} - ${this.city})`,
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
        },
        xAxis: {
          categories: this.charts[type]['labels'],
          labels: {
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
            },

            distance: 20,
            padding: 20,
          },
        },
        yAxis: {
          type: 'logarithmic',
          max: 5,
          labels: {
            formatter: () => '',
          },
        },
        tooltip: {
          formatter: function () {
            return this.y.toFixed(2)
          },
        },
        series: this.charts[type]['data'],
      }
    },
  },
}
</script>

<style>
#insights {
  height: 684px;
}

@media (max-width: 1024px) {
  #insights {
    height: auto;
  }
  .block .flex {
    flex-direction: column;
  }
}
</style>
